"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var LevelPermutationAnalyzerService = (function () {
    function LevelPermutationAnalyzerService() {
        this.addedLevelIds = [];
        this.removedLevelIds = [];
        this.rearrangedLevelIds = [];
    }
    LevelPermutationAnalyzerService.prototype.analize = function (currentLevelsId, existedLevelsId) {
        var levelsToUnlock = [];
        if (!existedLevelsId) {
            return;
        }
        var matrix = this.createLevenshteinMatrix(existedLevelsId, currentLevelsId);
        var i = existedLevelsId.length;
        var j = currentLevelsId.length;
        while (i > 0 || j > 0) {
            var top_1 = i - 1 >= 0 ? matrix[i - 1][j] : Infinity;
            var left = j - 1 >= 0 ? matrix[i][j - 1] : Infinity;
            var min = Math.min(top_1, left);
            if (i > 0 && j > 0 && existedLevelsId[i - 1] === currentLevelsId[j - 1]) {
                i--;
                j--;
            }
            else if (min === left) {
                this.insertLevel(currentLevelsId[j - 1]);
                j--;
            }
            else {
                this.removeLevel(existedLevelsId[i - 1]);
                i--;
            }
        }
    };
    LevelPermutationAnalyzerService.prototype.insertLevel = function (levelId) {
        if (this.removedLevelIds.indexOf(levelId) === -1) {
            this.addedLevelIds.push(levelId);
        }
        else {
            this.removedLevelIds = this.removedLevelIds.filter(function (id) { return id !== levelId; });
            this.rearrangedLevelIds.push(levelId);
        }
    };
    LevelPermutationAnalyzerService.prototype.removeLevel = function (levelId) {
        if (this.addedLevelIds.indexOf(levelId) === -1) {
            this.removedLevelIds.push(levelId);
        }
        else {
            this.addedLevelIds = this.addedLevelIds.filter(function (id) { return id !== levelId; });
            this.rearrangedLevelIds.push(levelId);
        }
    };
    LevelPermutationAnalyzerService.prototype.createLevenshteinMatrix = function (existed, current) {
        var existedSize = existed.length;
        var currentSize = current.length;
        var matrix = [];
        for (var i = 0; i <= existedSize; i++) {
            matrix[i] = [];
            matrix[i][0] = i;
        }
        for (var i = 0; i <= currentSize; i++) {
            matrix[0][i] = i;
        }
        for (var i = 1; i <= existedSize; i++) {
            for (var j = 1; j <= currentSize; j++) {
                if (existed[i - 1] === current[j - 1]) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                }
                else {
                    var top_2 = matrix[i - 1][j];
                    var left = matrix[i][j - 1];
                    matrix[i][j] = Math.min(top_2, left) + 1;
                }
            }
        }
        return matrix;
    };
    return LevelPermutationAnalyzerService;
}());
LevelPermutationAnalyzerService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], LevelPermutationAnalyzerService);
exports.LevelPermutationAnalyzerService = LevelPermutationAnalyzerService;



//////////////////
// WEBPACK FOOTER
// ./src/services/level-permutation-analyzer.service.ts
// module id = 144
// module chunks = 0